<template>
    <div class="ion-page">
        <ion-content class="outer-content ewallet">
            <div class="headerSectionWrapper ion-padding-horizontal">
                <div class="headerSection">
                    <div>
                        <p class="floatleft title">Current Balance</p>
                        <p class="floatright price">&#8377; {{summary ? summary.clearBalance : "0" | currency}}</p>
                    </div>
                    <div class="clearFix addMoney">
                        <input type="number" placeholder="Enter amount" v-model="amount" @keypress="onlyForCurrency"/>
                        <ion-button
                        class="btn-addMoney"
                        expand="block"
                        shape="round"
                        @click="onAddMoney"
                        >Add Money</ion-button>
                    </div>
                </div>
            </div>
            <ion-grid v-if="transactionsUserList && transactionsUserList.length > 0" class="history-list">
                <h3 class="historyTitle rp-desktop">History</h3>
                <h3 class="historyTitle rp-mobile">History</h3>
                <ion-row>
                    <ion-col
                        size-md="4" 
                        v-for="list in transactionsUserList"
                        :key="list"
                        class="ion-padding-30"
                        size-xs="12"
                    >
                        <div>
                            <ion-row class="ion-padding-vertical border-bottom-ion">
                                <ion-col>
                                    <p class="ion-no-margin title pg-description">{{ (list.status.code == 'S')? (list.remarks) : ("Payment attempted")}}</p>
                                    <p v-if="list.status.code == 'N'" class="ion-no-margin subtitle">{{list.status.description}}</p>
                                    <p v-if="list.status.code != 'N'" class="ion-no-margin subtitle">Ref:{{list.bankreference}}</p>
                                </ion-col>
                                <ion-col class="ion-text-end">
                                    <p class="ion-no-margin dateTime">{{changeDateFormat(list.date)}}</p>
                                    <p
                                        class="ion-no-margin price"
                                        v-bind:class="{'dangerColor': list.status.code == 'N' }"
                                    >&#8377; {{list.amount | currency}}</p>
                                </ion-col>
                            </ion-row>
                        </div>
                    </ion-col>
                </ion-row>
            </ion-grid>
            <div class="spinner">
                <ion-spinner v-if="loaderTab"></ion-spinner>
            </div>
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonContent, IonButton, IonGrid, IonRow, IonCol, IonSpinner } from "@ionic/vue";

import { Wallet } from "../../business/wallet";
import { WalletService } from "@/service/wallet/wallet.service";
import { ProfilerService } from "../../service/profile/profiler.service";
import { LocalStorage } from "../../data/localstorage";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import moment from 'moment';

import { Plugins } from '@capacitor/core';
const { Device } = Plugins;
import { Capacitor } from "@capacitor/core";

export default defineComponent ({
  name: 'wallet',
  components: {
    IonContent, IonButton, IonGrid, IonRow, IonCol, IonSpinner
  },
  data() {
    return {
      loaderTab: true,
      summary: null,
      profile: null,
      amount: null,
      pgcallbackurl: null,
      transactionsUserList: [],
      device: null,
      lstPath : null
    }
  },
  async mounted() {
    try {
      // this.device = await Device.getInfo();
      this.device = Capacitor.getPlatform()
      await this.initData();
      this.lstPath = this.$router.options.history.state.back
    }catch(error) {
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
    
  },

  methods: {
    changeDateFormat(dateValue) {
      return moment(dateValue).format('DD/MMM/YYYY')
    },

    onlyForCurrency ($event) {
      try {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

        // only allow number and one dot
        if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || (this.amount).toString().indexOf('.') != -1)) { // 46 is dot
          $event.preventDefault();
        }

        // restrict to 2 decimal places
        if(this.amount!=null && (this.amount).toString().indexOf(".")>-1 && (this.amount.split('.')[1].length > 1)){
          $event.preventDefault();
        }
      } catch(error) {
        // new AlertUtils().presentAlert(error);
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    },
    async initData() {
      try {
        this.transactionsUserList = [];
        this.summary = await new WalletService().summaryOfUser(
          new LocalStorage().user
        );
        this.profile = await new ProfilerService().profileOfUser(
          new LocalStorage().user
        );
        this.transactionsUserList = await new WalletService().transactionsOfUser(
          new LocalStorage().user
        );

      } catch(error) {
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
     
      this.loaderTab = false;
    },
    async onAddMoney() {
      try {
        if (
          typeof this.amount === "undefined" ||
          this.amount === null ||
          this.amount === "" ||
          (this.amount).toString().trim().length === 0
        ) {
          new ToastUtils().presentToast("Please enter amount");
        } else {
          this.callPaymentMethod();
          
        }
      } catch(error) {
        // new AlertUtils().presentAlert(error);
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    },

  callPaymentMethod() {
    var options = {
      // description: "RapidEVChargE wallet topups",
      // image: 'https://i.imgur.com/3g7nmJC.png',
      currency: "INR",
      key: "ThisWillBeFilledLaterFromAPI",
      protocol: "https",
      hostname: "api.razorpay.com",
      amount: this.amount * 100,
      name: this.profile.firstName,
      description: "Rapid EV Charge Wallet",
      prefill: {
        email: this.profile.email,
        contact: this.profile.mobile,
        name: this.profile.firstName
      },
      theme: {
        color: "#21b24b",
      },
      modal: {
      ondismiss: function () {
        console.log("Payment is dismissed");
      },
      },
      handler: function (transaction) {
      if (transaction.razorpay_payment_id) {
        callApi(transaction);
      }else{
        console.log("Handler Called:", transaction)
      }
      },
    };
    var successCallback = function (transaction) { 
      callApi(transaction);
    };
    var cancelCallback = function (error) {
      new AlertUtils().presentAlert(error.description);
    };

    var callApi = (transaction) => {
  
      // api to capture the payment
      new Wallet()
      .loadAmountToWalletForUser(transaction.razorpay_payment_id, transaction.razorpay_order_id, transaction.razorpay_signature,  this.pgcallbackurl)
      .then(async (response) => {
          this.loaderTab = true;
          new ToastUtils().presentToast("Wallet amount added successfully");
          this.amount = null;
          if(this.lstPath === "/customer/slotBookingForreservation") {
            this.loaderTab = false;
            this.$router.push("/customer/slotBookingForreservation");
          }else if(this.lstPath === "/customer/slotBooking"){
            this.loaderTab = false;
            this.$router.push("/customer/slotBooking");
          }else {
            await this.initData();
          }
          
      })
      .catch(async (error) => {
          // let serviceError = tryParseServiceError(error);
          // new AlertUtils().presentAlert(
          // serviceError ? serviceError : error
          // );
          // new AlertUtils().presentAlert(error.response.data.errors[0].detail);
          let serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
          this.loaderTab = true;
          this.amount = null;
          await this.initData();
      });
    };

    new Wallet()
      .initAmountToWalletForUser(this.amount, new LocalStorage().user)
      .then(async (response) => {
          if (response.links.pg_callbackurl) {
              this.pgcallbackurl = response.links.pg_callbackurl;
              if(response.meta){
                  if(response.meta.pg_url) options.hostname = response.meta.pg_url;
                  if(response.meta.pg_key) options.key = response.meta.pg_key;
                  if(response.meta.pg_currency) options.currency = response.meta.pg_currency;
                  if(response.meta.pg_title) options.name = response.meta.pg_title;
                  if(response.meta.pg_subtitle) options.description = response.meta.pg_subtitle;
                  if(response.meta.pg_orderid){
                  options.order_id = response.meta.pg_orderid;
                  } 
              }
              options["notes"] = {
              revc_transactionid : response.data.paymentId
              };
              //options["orderid"] = response.data.paymentId;
              

              if (
              /* if we're on iOS, Android, devices */
                this.device == "ios" ||
                this.device == "android"
              ) {
              RazorpayCheckout.on('payment.success', successCallback)
              RazorpayCheckout.on('payment.cancel', cancelCallback)
              RazorpayCheckout.open(options);//, successCallback, cancelCallback);
              } else {
              // for web
              // Razorpay.open(options, successCallback, cancelCallback);
              var razorpay = new Razorpay(options);
              razorpay.open();
              }
          }
      })
      .catch((error) => {
        // let serviceError = tryParseServiceError(error);
        // new AlertUtils().presentAlert(serviceError ? serviceError : error);
        // new AlertUtils().presentAlert(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      });
    },
  },
})
</script>

<style scoped>
.history-list {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  opacity: 1;
  min-height: 386px;
}

.headerSectionWrapper {
  margin-top: 20px;
  margin-bottom: 17px;
}

@media (min-width: 768px) {
  .history-list .ion-padding-30 {
    padding-left: 30px;
    padding-right: 30px;
  }

  .rp-mobile {
    display: none;
  }

  .rp-desktop {
    display: block;
  }
}

@media (max-width: 768px) {
  .rp-mobile {
    display: block;
  }
  .history-list .ion-padding-30 {
    padding-left: 15px;
    padding-right: 15px;
  }
  .rp-desktop {
    display: none;
  }
}

.border-bottom-ion p {
  margin: 5px 0;
}

.history-list .title {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0;
  font-family: "Roboto";
  color: #000000;
  opacity: 1;
}

.history-list .subtitle {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0;
  font-family: "Roboto";
  color: #000000;
  opacity: 0.5;
}

.border-bottom-ion {
  border-bottom: 1px solid #e5e5e5;
}

.history-list .dateTime {
  font-size: 14px;
  letter-spacing: 0;
  font-family: "Roboto";
  letter-spacing: 0;
  color: #000000;
  opacity: 0.5;
}

.history-list .price.dangerColor {
  color: #db7f7f;
}

.history-list .price {
  font-size: 14px;
  letter-spacing: 0;
  font-family: "Roboto Medium";
  color: #21b24b;
  opacity: 1;
}

.headerSection {
  height: 151px;
  background: #21b24b 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 16px;
  opacity: 1;
  padding: 16px;
}

.ewallet .historyTitle {
  text-align: left;
  font-size: 14px;

  font-family: "Roboto Bold";
  letter-spacing: 0;
  color: #21315d;
  opacity: 1;
  padding-left: 18px;
}

.ewallet .historyTitle.rp-desktop {
  height: 37px;
  
}

.headerSection .title {
  text-align: left;
  font-size: 15px;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 0.75;
  line-height: 24px;
  margin: 0;
}

.headerSection .price {
  text-align: left;
  font-size: 26px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  margin: 0;
}

.btn-addMoney {
  height: 24px;
  position: absolute;
  --background: #21b24b !important;
  color: #ffffff;
  --background-focused: #21b24b !important;
  --background-hover: #21b24b !important;
  width: 99px;
  border-radius: 36px;
  font-size: 13px;
  font-family: "Roboto Medium";
  top: 9px;
  right: 12px;
  text-transform: capitalize;
}

.addMoney input {
  width: 100%;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  border-radius: 12px;
  opacity: 1;
  height: 52px;
  font-size: 14px;
  color: #000;
  padding: 12px;
}

.addMoney {
  position: relative;
  top: 15px;
}

.floatright {
  float: right;
}

.floatleft {
  float: left;
}

.clearFix {
  clear: both;
}

.pg-description{
  white-space: nowrap !important;
}
</style>